import * as reducer from './reducers';

import * as projectTypes from './types';
import * as projectOperation from './operations';
import * as projectActions from './actions';
import * as projectSelectors from './selectors';

export { projectTypes, projectOperation, projectActions, projectSelectors };

export default reducer;
